import { Flow_0_0_2 } from '@flexus/core';

export const BET_65: Flow_0_0_2 = {
	id: '65',
	name: 'private_work_sp_notification',
	itemType: 'flow',
	header: {
		title: '',
		controls: () => () => []
	},
	footer: {
		type: 'node_nav'
	},
	instructions: {
		editRoles: {
			0: 'Private Work'
		},
		viewRoles: {
			0: 'Private Work'
		}
	},
	startNode: '',
	nodes: {}
};
